module.exports = __webpack_public_path__ + "img/05.077f8fae.jpg";